export var fileAttachmentTheme = {
  baseStyle: _ref => {
    var {
      isEmpty,
      onViewModeClick,
      width
    } = _ref;
    return {
      container: {
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center'
      },
      fileImageContainer: {
        display: 'inline-flex',
        position: 'relative',
        overflow: 'hidden',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: "".concat(width, "px"),
        height: 'auto',
        maxWidth: '176px',
        maxHeight: '224px',
        minWidth: '50px',
        aspectRatio: '176 / 224',
        border: isEmpty ? 'surface.empty' : 'surface.default',
        borderRadius: 'l',
        cursor: 'pointer',
        shadow: 500,
        transition: 'box-shadow 0.1s ease-in-out',
        _hover: {
          cursor: 'pointer',
          shadow: 600
        },
        _loading: {
          shadow: 500,
          cursor: 'default'
        },
        _active: {
          shadow: 600
        },
        '&[data-view-mode="true"]': {
          shadow: !isEmpty ? 500 : 0,
          _hover: {
            cursor: !isEmpty ? 'pointer' : 'default',
            shadow: !isEmpty ? 600 : 0
          }
        },
        _readOnly: {
          shadow: 0,
          _hover: {
            cursor: 'default',
            shadow: 0
          }
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineWidth: '2px',
          outlineOffset: '2px',
          outlineStyle: 'solid'
        }
      },
      pdf: {
        position: 'absolute',
        width: '180px',
        height: '233px',
        overflow: 'hidden'
      },
      attachmentIconContainer: {
        position: 'absolute',
        zIndex: 'dropdown',
        display: 'flex',
        borderRadius: 'm',
        justifyContent: 'center',
        alignItems: 'center',
        '&[data-view-mode="true"]': {
          width: '24px',
          height: '24px',
          backgroundColor: 'neutral.black',
          opacity: 0.3,
          top: '16px',
          right: '16px',
          _hover: {
            opacity: onViewModeClick && 0.6,
            transition: onViewModeClick && 'opacity 0.1s ease-in-out'
          }
        },
        _readOnly: {
          width: '24px',
          height: '24px',
          backgroundColor: 'neutral.black',
          opacity: 0.3,
          top: '16px',
          right: '16px'
        }
      },
      editIcon: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'neutral.white',
        cursor: 'pointer'
      },
      deleteButton: {
        marginTop: 's'
      },
      noPreview: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        opacity: 0.6,
        textStyle: 'body4',
        textAlign: 'center',
        paddingX: 'm',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        wordBreak: 'break-word',
        maxWidth: '100%'
      }
    };
  }
};
//# sourceMappingURL=FileAttachment.theme.js.map